import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowRight } from "lucide-react";
import BrandIcon from "./BrandIcon";
import LanguageSwitcher from "./LanguageSwitcher";
import { useLangPrefix } from "../../lib/langRoutes";

export function PublicNav() {
  const { t } = useTranslation();
  const lp = useLangPrefix();
  return (
    <header className="sticky top-0 z-40 bg-slate-950/80 backdrop-blur border-b border-slate-800/80">
      <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
        <Link to={`${lp}/`} className="flex items-center gap-2" data-testid="public-nav-logo">
          <BrandIcon size={32} />
          <span className="font-display font-bold text-lg text-white">MachinePilot</span>
        </Link>
        <div className="flex items-center gap-4">
          <Link to={`${lp}/blog`} className="text-sm text-slate-400 hover:text-white hidden sm:block" data-testid="public-nav-blog">Blog</Link>
          <LanguageSwitcher compact />
          <Link to="/register" className="btn-primary px-4 py-2 rounded-md text-sm" data-testid="public-nav-cta">
            {t("landing.capabilityCommon.ctaPrimary")}
          </Link>
        </div>
      </div>
    </header>
  );
}

export function PublicCta({ title, body, button }) {
  return (
    <section className="max-w-6xl mx-auto px-6 py-14">
      <div className="tech-card p-10 text-center" data-testid="public-cta">
        <h2 className="font-display text-2xl md:text-3xl font-bold text-white mb-3">{title}</h2>
        <p className="text-slate-400 max-w-xl mx-auto mb-6">{body}</p>
        <Link to="/register" className="btn-primary inline-flex items-center gap-2 px-6 py-3 rounded-md" data-testid="public-cta-button">
          {button} <ArrowRight size={16}/>
        </Link>
      </div>
    </section>
  );
}

export function PublicFooter() {
  const { t } = useTranslation();
  const lp = useLangPrefix();
  return (
    <footer className="border-t border-slate-800 py-8 mt-8">
      <div className="max-w-6xl mx-auto px-6 flex items-center justify-between flex-wrap gap-3 text-sm text-slate-500">
        <span>© {new Date().getFullYear()} MachinePilot · machinepilot.eu</span>
        <div className="flex gap-4">
          <Link to={`${lp}/`} className="hover:text-white">{t("landing.capabilityCommon.backToHome")}</Link>
          <Link to={`${lp}/blog`} className="hover:text-white">Blog</Link>
          <Link to={`${lp}/privacy`} className="hover:text-white">Privacy</Link>
        </div>
      </div>
    </footer>
  );
}
